module.exports = __webpack_public_path__ + "static/media/ava.d5eb1d92.jpg";